package com.milta.core.localization.translations.en

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Optimization quota reached",
    exhaustedCreateRouteMessage = "Back on {date}. You can create the route without optimization: the entered order is kept.",
    exhaustedCreateBatchMessage = "Back to {limit} optimizations on {date}. The batch can be created without optimization: the entered order is kept.",
    quotaReachedResetOn = "Optimization quota reached — resets on {date}",
    routeCreatedInEnteredOrder = "Route created in the entered order.",
    routeWillBeCreatedInEnteredOrder = "The route will be created in the entered order.",
    batchCreatedInEnteredOrder = "The batch was created without optimization, in the entered order.",
    sendWithoutOptimization = "Send without optimization",
    batchNotOptimizedTitle = "Batch created without optimization",
    batchNotOptimizedMessage = "Optimization quota reached. The current stop order is kept.",
    batchNotOptimizedMobileMessage = "Batch created without optimization: optimization quota reached. Entered order kept, stops split evenly.",
    reoptimizeAction = "Re-optimize",
    reoptimizeUnavailableWeb = "Re-optimization unavailable: quota reached, back on {date}. The current order is kept and sending is still possible.",
    reoptimizeUnavailableMobile = "Re-optimization unavailable until {date} (quota reached). Sending is still possible.",
    stopAddedAtEndTitle = "Stop added at the end of the route",
    stopAddedAtEndMessage = "Optimization quota reached — resets on {date}. The order of the other stops does not change.",
    reoptimizeExhaustedHint = "Optimization quota reached, back on {date}",
    myOptimizationsTitle = "My optimizations",
    remainingForPeriod = "Left for this period",
    remainingSuffix = "left",
    resetLabel = "Reset",
    resetAtRenewal = "At subscription renewal",
    driverExplanation = "Resets when your subscription renews. Driver of an Enterprise: your counter follows the Enterprise's subscription, with the trial limit while it is on trial.",
    enterpriseExplanation = "Resets when your subscription renews. This counter only covers your own optimizations; each driver has their own.",
    webCounterNotice = "This counter only covers optimizations launched by this account. Each driver has their own, visible in their app.",
    historyTitle = "History",
    columnDate = "Date",
    columnAction = "Action",
    columnTarget = "Route",
    columnOutcome = "Result",
    actionOptimizeRoute = "Optimize a route",
    actionCreateRouteBatch = "Create a batch",
    actionReoptimizeRouteBatch = "Re-optimize a batch",
    actionReoptimizeOnStopAdded = "Re-optimize when adding a stop",
    actionReoptimizeInPlace = "Re-optimize on the go",
    actionCreateOwnRoute = "Create my route",
    outcomeCounted = "Counted",
    outcomeRefunded = "Refunded",
    outcomeRefundedLong = "Refunded — RoutaR failure",
    refundedNotCounted = "RoutaR failure, not counted",
    targetRoute = "Route of {date}",
    targetBatch = "Batch of {date}",
    historyLoadingMore = "Loading the next rows…",
    historyEnd = "End of history — {count} rows",
    historyEmpty = "No optimization in this period.",
    historyLoadError = "Could not load the history.",
    retryAction = "Retry",
    loading = "Loading…",
    errorNoConnection = "Could not reach the server — check your connection.",
    errorGeneric = "Something went wrong. Please try again later.",
    tabOptimizations = "RoutaR optimizations",
    tabAiTokens = "AI tokens",
    comingSoon = "Coming soon",
    limitsDescription = "Number of RoutaR optimizations allowed per account and per subscription period, by account type and subscription status. Each account's counter resets when its subscription renews.",
    columnTrial = "Trial",
    columnPaid = "Paid",
    rowEnterprise = "Enterprise account",
    rowDriver = "Driver",
    fieldRequired = "Required field.",
    fieldMustBePositive = "Must be greater than 0.",
    limitsFootnote = "Values in optimizations per period. An Enterprise's driver gets the \"Driver\" limit, trial while their Enterprise is on trial, paid otherwise.",
    limitsSaved = "Limits saved. Enterprise: {enterpriseTrial} trial · {enterprisePaid} paid. Driver: {driverTrial} trial · {driverPaid} paid.",
    limitsRejected = "Values rejected: each limit must be greater than 0.",
    saveAction = "Save",
    detailsAction = "Details",
    accountDetailsTitle = "User details",
    sectionIdentity = "Identity",
    accountTypeLabel = "Account type",
    kindEnterpriseOwner = "Enterprise account",
    kindEnterpriseDriver = "Enterprise driver",
    kindIndependentDriver = "Independent driver",
    withoutOrganisation = "No organisation",
    subscriptionLabel = "Subscription",
    viaOrganisation = "Via organisation",
    subscriptionTrial = "Trial",
    subscriptionPaid = "Paid",
    appliedLimitLabel = "Applied limit",
    limitKindEnterprise = "Enterprise account limit",
    limitKindDriver = "Driver limit",
    enterpriseInTrialSuffix = "(the Enterprise is on trial)",
    resetSourceOwn = "Subscription renewal",
    resetSourceEnterprise = "Renewal of {enterprise}",
    exhaustedBadge = "Quota used up",
    manuallyAdjustedBadge = "Manually replaced",
    replaceLabel = "Replace the remaining count",
    replaceAction = "Replace",
    replaceHelp = "For the current period only. At reset, the account starts again from the global limit.",
    replaceHelpEnterpriseDriver = "Only changes {name}'s counter. The Enterprise's and the other drivers' counters do not change.",
    replaceInvalid = "Enter a number greater than or equal to 0.",
    replaceRejected = "Value rejected by the server.",
    replaceMaximum = "Maximum 100,000.",
    replacedBanner = "Remaining count replaced: {from} → {to}. For the current period. On {date}, back to the global limit ({limit}).",
    adminHistoryTitle = "Optimization history",
    accountNotFound = "Account not found.",
)
